import { Container, Title, Text, Stack, Box } from '@mantine/core';
import classes from './FaqSimple.module.css';

const data = [
  {
    value: 'pricing',
    question: 'SmartMenuのメニュー翻訳サービスは無料で使えますか？',
    answer: 'ベータ版期間中は月額利用料が無料でお試しいただけます。',
  },
  {
    value: 'qr-codes',
    question: 'お客様はアプリのダウンロードなど特別な準備が必要ですか？',
    answer: 'いいえ。ご自身のスマートフォンでQRコードを読み取れば、そのまま注文することができます。',
  }
];

export function FaqSimple() {
  return (
    <Container className={classes.wrapper} size="lg">
      <Title ta="center" className={classes.title}>
        よくあるご質問
      </Title>

      <Stack gap="lg" className={classes.accordion}>
        {data.map((item) => (
          <Box key={item.value} className={classes.item}>
            <Text fw={600} size="lg" mb="xs" className={classes.control}>
              {item.question}
            </Text>
            <Text c="dimmed" className={classes.content}>
              {item.answer}
            </Text>
          </Box>
        ))}
      </Stack>
    </Container>
  );
} 